<template>
  <div>
    <h2 v-if="!hideHeader"
        class="dadosFalecimBox_header"
        :class="{'dadosFalecimBox_header_error': errors_general}">
      Causas de Óbito
      <span v-if="errors_general">
        <IconSvg class="icon-error-campo"
                 icon="alert" />
        Há campos incorretos
      </span>
    </h2>
    <form class="px-2 pt-2 mb-3"
          novalidate>
      <div class="row">
        <div class="col-sm-4 col-md-3">
          <label class="label"
                 :class="{'label-error': error_tipo_morte}"
                 for="tipo_morte">
            Tipo de Morte
            <span v-if="error_tipo_morte">
              <IconSvg class="icon-error-campo"
                       icon="alert" />
            </span>
          </label>

          <select id="tipo_morte"
                  v-model="localData.tipo_morte"
                  class="custom-select custom-select-sm"
                  :class="{'is-invalid':errors.has('tipo_morte') || error_tipo_morte }"
                  name="tipo_morte"
                  @change="changed">
            <option selected
                    :value="null">
              Selecione
            </option>
            <option v-for="causa in selectsOptions.causasMorte"
                    :key="causa.id"
                    :value="causa.name.toUpperCase()">
              {{ causa.name }}
            </option>
          </select>
          <small v-if="errors.has('tipo_morte')"
                 class="invalid-feedback">{{ errors.first('tipo_morte') }}</small>
          <small v-else-if="error_tipo_morte"
                 class="invalid-feedback">Campo incorreto</small>
        </div>
      </div>

      <div>
        <span class="label--sm my-3 d-inline-block"
              :class="{'label-error': error_parte_one}">
          Parte I - Causas Antecedentes (Estados mórbidos se existirem, que produziram a causa registrada, mencionando-se em último lugar a causa básica)
          <IconSvg v-if="error_parte_one"
                   class="icon-error-campo"
                   icon="alert" />
        </span>

        <div class="row align-items-center">
          <div class="col-1">
            <div class="form-group text-center">
              <label class="label"
                     for="causa_morte_parte_1_a">a)</label>
            </div>
          </div>

          <div class="col-11">
            <div class="form-group">
              <input id="causa_morte_parte_1_a"
                     v-model="localData.causa_morte_parte_1_a"
                     class="form-control form-control-sm"
                     name="causa_morte_parte_1_a"
                     placeholder="Devido ou como consequência de"
                     type="text"
                     @change="changed">
            </div>
          </div>

          <div class="col-1">
            <div class="form-group text-center">
              <label class="label"
                     for="causa_morte_parte_1_b">b)</label>
            </div>
          </div>

          <div class="col-11">
            <div class="form-group">
              <input id="causa_morte_parte_1_b"
                     v-model="localData.causa_morte_parte_1_b"
                     class="form-control form-control-sm"
                     name="causa_morte_parte_1_b"
                     placeholder="Devido ou como consequência de"
                     type="text"
                     @change="changed">
            </div>
          </div>

          <div class="col-1">
            <div class="form-group text-center">
              <label class="label"
                     for="causa_morte_parte_1_c">c)</label>
            </div>
          </div>

          <div class="col-11">
            <div class="form-group">
              <input id="causa_morte_parte_1_c"
                     v-model="localData.causa_morte_parte_1_c"
                     class="form-control form-control-sm"
                     name="causa_morte_parte_1_c"
                     placeholder="Devido ou como consequência de"
                     type="text"
                     @change="changed">
            </div>
          </div>

          <div class="col-1">
            <div class="form-group text-center">
              <label class="label"
                     for="causa_morte_parte_1_d">d)</label>
            </div>
          </div>

          <div class="col-11">
            <div class="form-group">
              <input id="causa_morte_parte_1_d"
                     v-model="localData.causa_morte_parte_1_d"
                     class="form-control form-control-sm"
                     name="causa_morte_parte_1_d"
                     placeholder="Devido ou como consequência de"
                     type="text"
                     @change="changed">
            </div>
          </div>
        </div>

        <span class="label--sm my-3 d-inline-block"
              :class="{'label-error': error_parte_two}">
          Parte II - Outras condições significativas que contribuíram para a morte, e que não entraram
          <IconSvg v-if="error_parte_two"
                   class="icon-error-campo"
                   icon="alert" />
        </span>
        <div class="form-group">
          <input id="causa_morte_parte_2_a"
                 v-model="localData.causa_morte_parte_2_a"
                 class="form-control form-control-sm"
                 name="causa_morte_parte_2_a"
                 placeholder="Devido ou como consequência de"
                 type="text"
                 @change="changed">
        </div>

        <div class="form-group">
          <input id="causa_morte_parte_2_b"
                 v-model="localData.causa_morte_parte_2_b"
                 class="form-control form-control-sm"
                 name="causa_morte_parte_2_b"
                 placeholder="Devido ou como consequência de"
                 type="text"
                 @change="changed">
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'CausaObito',
    components: { },
    inject: ['$validator'],
    props: {
      data: { type: Object, default: () => {} },
      propCorrecoes: {type: Object, default: () => ({})},
      propNatimorto: { type: Boolean, default: () => false },
      hideHeader: { type: Boolean, default: false}

    },
    data () {
      return {
        tipo: null,
        localData: {
          tipo_morte: null
        },
        selectsOptions: {
          causasMorte: []
        },
        errors_general: false,
        error_tipo_morte: false,
        error_parte_one: false,
        error_parte_two: false,
      }
    },
    watch: {
      data: function (newObj, oldObj) {
        this.setObj()

        if (Object.entries(this.localData).some(val => this.localData[val] !== this.data[val])) {
          this.changed()
        }
      },
      propCorrecoes () {
        this.verifyErrorsCarga()
      },
      propNatimorto () {
        this.verifyType()
      }
    },
    mounted () {
      this.setObj()
      this.verifyErrorsCarga()
      this.verifyType()

    },
    methods: {
      setObj () {
        const obj = this.data && this.data.causaObito ? { ...this.data.causaObito } : { ...this.data }

        this.localData = {
          tipo_morte: obj.tipo_morte || null,
          causa_morte_parte_1_a: obj.causa_morte_parte_1_a || null,
          causa_morte_parte_1_b: obj.causa_morte_parte_1_b || null,
          causa_morte_parte_1_c: obj.causa_morte_parte_1_c || null,
          causa_morte_parte_1_d: obj.causa_morte_parte_1_d || null,
          causa_morte_parte_2_a: obj.causa_morte_parte_2_a || null,
          causa_morte_parte_2_b: obj.causa_morte_parte_2_b || null,
        }

        /**
         * Tratamos os tipos de morte que vem da migração para os tipos usados
         * no rei
         */

        const { causa_morte_parte_1_a, causa_morte_parte_1_b,
                causa_morte_parte_1_c, causa_morte_parte_1_d,
                causa_morte_parte_2_a, causa_morte_parte_2_b } = this.localData

        let causas = [ causa_morte_parte_1_a, causa_morte_parte_1_b,
                       causa_morte_parte_1_c, causa_morte_parte_1_d,
                       causa_morte_parte_2_a, causa_morte_parte_2_b ]

        causas = causas.filter(causa => causa !== 'IGNORADA' && causa !== 'ignorada' && !!causa)

        if (!this.propNatimorto && causas && causas.length && this.localData.tipo_morte === 'VIOLENTA') {
          this.localData.tipo_morte = 'OUTRO TIPO DE MORTE VIOLENTA'
        } else if (!this.propNatimorto && this.localData.tipo_morte === 'VIOLENTA') {
          this.localData.tipo_morte = 'MORTE VIOLENTA COM CAUSA IGNORADA'
        }
      },
      changed (event) {
        if (event) {
          if (event.target.name.match('causa_morte_parte_1')) this.deleteError(['CAUSA MORTE PARTE 1', 'CAUSA MORTE PARTE I'])
          else if (event.target.name.match('causa_morte_parte_2')) this.deleteError(['CAUSA MORTE PARTE 2', 'CAUSA MORTE PARTE II'])
          else if (event.target.name.match('tipo_morte')) this.deleteError(['TIPO DE MORTE'])
        }
        this.$emit('changed', this.localData)
      },
      verifyType () {
        if (!this.propNatimorto) {
          this.selectsOptions = {
            causasMorte: [
              { id: 1, name: 'Natural', value: 'Natural' },
              { id: 2, name: 'Acidente', value: 'Acidente' },
              { id: 3, name: 'Ignorada', value: 'Ignorada' },
              { id: 4, name: 'Suicídio', value: 'Suicídio' },
              { id: 5, name: 'Homicídio', value: 'Homicídio' },
              { id: 6, name: 'Outro tipo de morte violenta', value: 'Outro tipo de morte violenta' },
              { id: 7, name: 'Morte violenta com causa Ignorada', value: 'Morte violenta com causa Ignorada' },
            ]
          }
        }
        else {
          this.selectsOptions = {
            causasMorte: [
              { id: 1, name: 'Natural', value: 'Natural' },
              { id: 2, name: 'Violenta', value: 'Violenta' },
              { id: 3, name: 'Ignorada', value: 'Ignorada' },
            ]}
        }
      },

      deleteError (error) {
        this.$emit('deleteError', error)
      },
      verifyErrorsCarga () {
        this.errors_general = false
        this.error_tipo_morte = false
        this.error_parte_one = false
        this.error_parte_two = false

        const errors = [
          'CAUSA MORTE',
          'CAUSA MORTE PARTE 1',
          'CAUSA MORTE PARTE I',
          'CAUSA MORTE PARTE II',
          'CAUSA MORTE PARTE 2',
          'TIPO DE MORTE'
        ]

        Object.keys(this.propCorrecoes).forEach(key => {
          if (errors.indexOf(key) != -1) this.errors_general = true

          if (['TIPO DE MORTE'].indexOf(key) != -1) this.error_tipo_morte = true

          if (['CAUSA MORTE PARTE 1', 'CAUSA MORTE PARTE I'].indexOf(key) != -1) this.error_parte_one = true

          if (['CAUSA MORTE PARTE 2', 'CAUSA MORTE PARTE II'].indexOf(key) != -1) this.error_parte_two = true
        })
      }
    }
  }
</script>

<style scoped />
